<template>
  <router-view />
</template>

<script>
export default {
  name: 'AppRoot',
}
</script>
